import * as Yup from "yup";
import { StockLocationType } from "../constants/stock-location.constants";

const schema = Yup.object({
  name: Yup.string()
    .trim()
    .required("Name is required")
    .max(255, "Name is too long"),
  type: Yup.mixed<StockLocationType>()
    .oneOf(Object.values(StockLocationType))
    .required("Type is required"),
  city: Yup.string()
    .trim()
    .required("City is required")
    .max(100, "City is too long"),
  state: Yup.string()
    .trim()
    .required("State is required")
    .max(100, "State is too long"),
});

export default schema;
